import { default as _91_46_46_46all_93JxqKXoqnfXMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/[...all].vue?macro=true";
import { default as categoryFCld8gNkKHMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/category.vue?macro=true";
import { default as editordrxn4eyxX7Meta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/editor.vue?macro=true";
import { default as indexmtxfZor9SNMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/index.vue?macro=true";
import { default as navLCwnjPfb3jMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/nav.vue?macro=true";
import { default as homeSgI0u6cVK0Meta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/home.vue?macro=true";
import { default as indexMGmivLPzHoMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/admin/index.vue?macro=true";
import { default as btZZ1gwiqNVXMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/bt.vue?macro=true";
import { default as CaseListAPN1Iz6UNzMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/CaseList.vue?macro=true";
import { default as detail1BHgRzJ3DdwMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail1.vue?macro=true";
import { default as detail2tPk4zYsamfMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail2.vue?macro=true";
import { default as detail3rWFi28y5tRMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail3.vue?macro=true";
import { default as detail4M7np9Dbw84Meta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail4.vue?macro=true";
import { default as detail5tbMiSDzg4OMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail5.vue?macro=true";
import { default as detail6F584Zh2W8QMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail6.vue?macro=true";
import { default as listONaRWw2VbUMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/case/list.vue?macro=true";
import { default as _91key_93FIG1xhQsADMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/doc/[cateKey]/[key].vue?macro=true";
import { default as x0uqquOZ0JwMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/fun/x.vue?macro=true";
import { default as _91id_93r9moj1wcUOMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/hi/[id].vue?macro=true";
import { default as indexwkJPiqqmOWMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/index.vue?macro=true";
import { default as loginPIvVUxICJbMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/login.vue?macro=true";
import { default as news1113tSP7H91NJ7Meta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/news/news1113.vue?macro=true";
import { default as niumKXGBmSX4tjMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/nium.vue?macro=true";
import { default as indexbwZgCAF2YqMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/price/index.vue?macro=true";
import { default as proIdcRxhQTXSMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/pro.vue?macro=true";
import { default as PriceXeC2pP6hayMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/scheme/Price.vue?macro=true";
import { default as testAwQYuIsOemMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/test.vue?macro=true";
import { default as xWAwW1YoS5SMeta } from "/home/deploy/webhook-lisenter/tduck-cms/pages/x.vue?macro=true";
export default [
  {
    name: _91_46_46_46all_93JxqKXoqnfXMeta?.name ?? "all",
    path: _91_46_46_46all_93JxqKXoqnfXMeta?.path ?? "/:all(.*)*",
    meta: _91_46_46_46all_93JxqKXoqnfXMeta || {},
    alias: _91_46_46_46all_93JxqKXoqnfXMeta?.alias || [],
    redirect: _91_46_46_46all_93JxqKXoqnfXMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/[...all].vue").then(m => m.default || m)
  },
  {
    name: categoryFCld8gNkKHMeta?.name ?? "admin-document-category",
    path: categoryFCld8gNkKHMeta?.path ?? "/admin/document/category",
    meta: categoryFCld8gNkKHMeta || {},
    alias: categoryFCld8gNkKHMeta?.alias || [],
    redirect: categoryFCld8gNkKHMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/category.vue").then(m => m.default || m)
  },
  {
    name: editordrxn4eyxX7Meta?.name ?? "admin-document-editor",
    path: editordrxn4eyxX7Meta?.path ?? "/admin/document/editor",
    meta: editordrxn4eyxX7Meta || {},
    alias: editordrxn4eyxX7Meta?.alias || [],
    redirect: editordrxn4eyxX7Meta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/editor.vue").then(m => m.default || m)
  },
  {
    name: indexmtxfZor9SNMeta?.name ?? "admin-document",
    path: indexmtxfZor9SNMeta?.path ?? "/admin/document",
    meta: indexmtxfZor9SNMeta || {},
    alias: indexmtxfZor9SNMeta?.alias || [],
    redirect: indexmtxfZor9SNMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/index.vue").then(m => m.default || m)
  },
  {
    name: navLCwnjPfb3jMeta?.name ?? "admin-document-nav",
    path: navLCwnjPfb3jMeta?.path ?? "/admin/document/nav",
    meta: navLCwnjPfb3jMeta || {},
    alias: navLCwnjPfb3jMeta?.alias || [],
    redirect: navLCwnjPfb3jMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/document/nav.vue").then(m => m.default || m)
  },
  {
    name: homeSgI0u6cVK0Meta?.name ?? "admin-home",
    path: homeSgI0u6cVK0Meta?.path ?? "/admin/home",
    meta: homeSgI0u6cVK0Meta || {},
    alias: homeSgI0u6cVK0Meta?.alias || [],
    redirect: homeSgI0u6cVK0Meta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/home.vue").then(m => m.default || m)
  },
  {
    name: indexMGmivLPzHoMeta?.name ?? "admin",
    path: indexMGmivLPzHoMeta?.path ?? "/admin",
    meta: indexMGmivLPzHoMeta || {},
    alias: indexMGmivLPzHoMeta?.alias || [],
    redirect: indexMGmivLPzHoMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: btZZ1gwiqNVXMeta?.name ?? "bt",
    path: btZZ1gwiqNVXMeta?.path ?? "/bt",
    meta: btZZ1gwiqNVXMeta || {},
    alias: btZZ1gwiqNVXMeta?.alias || [],
    redirect: btZZ1gwiqNVXMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/bt.vue").then(m => m.default || m)
  },
  {
    name: CaseListAPN1Iz6UNzMeta?.name ?? "case-CaseList",
    path: CaseListAPN1Iz6UNzMeta?.path ?? "/case/CaseList",
    meta: CaseListAPN1Iz6UNzMeta || {},
    alias: CaseListAPN1Iz6UNzMeta?.alias || [],
    redirect: CaseListAPN1Iz6UNzMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/CaseList.vue").then(m => m.default || m)
  },
  {
    name: detail1BHgRzJ3DdwMeta?.name ?? "case-detail1",
    path: detail1BHgRzJ3DdwMeta?.path ?? "/case/detail1",
    meta: detail1BHgRzJ3DdwMeta || {},
    alias: detail1BHgRzJ3DdwMeta?.alias || [],
    redirect: detail1BHgRzJ3DdwMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail1.vue").then(m => m.default || m)
  },
  {
    name: detail2tPk4zYsamfMeta?.name ?? "case-detail2",
    path: detail2tPk4zYsamfMeta?.path ?? "/case/detail2",
    meta: detail2tPk4zYsamfMeta || {},
    alias: detail2tPk4zYsamfMeta?.alias || [],
    redirect: detail2tPk4zYsamfMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail2.vue").then(m => m.default || m)
  },
  {
    name: detail3rWFi28y5tRMeta?.name ?? "case-detail3",
    path: detail3rWFi28y5tRMeta?.path ?? "/case/detail3",
    meta: detail3rWFi28y5tRMeta || {},
    alias: detail3rWFi28y5tRMeta?.alias || [],
    redirect: detail3rWFi28y5tRMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail3.vue").then(m => m.default || m)
  },
  {
    name: detail4M7np9Dbw84Meta?.name ?? "case-detail4",
    path: detail4M7np9Dbw84Meta?.path ?? "/case/detail4",
    meta: detail4M7np9Dbw84Meta || {},
    alias: detail4M7np9Dbw84Meta?.alias || [],
    redirect: detail4M7np9Dbw84Meta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail4.vue").then(m => m.default || m)
  },
  {
    name: detail5tbMiSDzg4OMeta?.name ?? "case-detail5",
    path: detail5tbMiSDzg4OMeta?.path ?? "/case/detail5",
    meta: detail5tbMiSDzg4OMeta || {},
    alias: detail5tbMiSDzg4OMeta?.alias || [],
    redirect: detail5tbMiSDzg4OMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail5.vue").then(m => m.default || m)
  },
  {
    name: detail6F584Zh2W8QMeta?.name ?? "case-detail6",
    path: detail6F584Zh2W8QMeta?.path ?? "/case/detail6",
    meta: detail6F584Zh2W8QMeta || {},
    alias: detail6F584Zh2W8QMeta?.alias || [],
    redirect: detail6F584Zh2W8QMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/detail6.vue").then(m => m.default || m)
  },
  {
    name: listONaRWw2VbUMeta?.name ?? "case-list",
    path: listONaRWw2VbUMeta?.path ?? "/case/list",
    meta: listONaRWw2VbUMeta || {},
    alias: listONaRWw2VbUMeta?.alias || [],
    redirect: listONaRWw2VbUMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/case/list.vue").then(m => m.default || m)
  },
  {
    name: _91key_93FIG1xhQsADMeta?.name ?? "doc-cateKey-key",
    path: _91key_93FIG1xhQsADMeta?.path ?? "/doc/:cateKey()/:key()",
    meta: _91key_93FIG1xhQsADMeta || {},
    alias: _91key_93FIG1xhQsADMeta?.alias || [],
    redirect: _91key_93FIG1xhQsADMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/doc/[cateKey]/[key].vue").then(m => m.default || m)
  },
  {
    name: x0uqquOZ0JwMeta?.name ?? "fun-x",
    path: x0uqquOZ0JwMeta?.path ?? "/fun/x",
    meta: x0uqquOZ0JwMeta || {},
    alias: x0uqquOZ0JwMeta?.alias || [],
    redirect: x0uqquOZ0JwMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/fun/x.vue").then(m => m.default || m)
  },
  {
    name: _91id_93r9moj1wcUOMeta?.name ?? "hi-id",
    path: _91id_93r9moj1wcUOMeta?.path ?? "/hi/:id()",
    meta: _91id_93r9moj1wcUOMeta || {},
    alias: _91id_93r9moj1wcUOMeta?.alias || [],
    redirect: _91id_93r9moj1wcUOMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/hi/[id].vue").then(m => m.default || m)
  },
  {
    name: indexwkJPiqqmOWMeta?.name ?? "index",
    path: indexwkJPiqqmOWMeta?.path ?? "/",
    meta: indexwkJPiqqmOWMeta || {},
    alias: indexwkJPiqqmOWMeta?.alias || [],
    redirect: indexwkJPiqqmOWMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginPIvVUxICJbMeta?.name ?? "login",
    path: loginPIvVUxICJbMeta?.path ?? "/login",
    meta: loginPIvVUxICJbMeta || {},
    alias: loginPIvVUxICJbMeta?.alias || [],
    redirect: loginPIvVUxICJbMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/login.vue").then(m => m.default || m)
  },
  {
    name: news1113tSP7H91NJ7Meta?.name ?? "news-news1113",
    path: news1113tSP7H91NJ7Meta?.path ?? "/news/news1113",
    meta: news1113tSP7H91NJ7Meta || {},
    alias: news1113tSP7H91NJ7Meta?.alias || [],
    redirect: news1113tSP7H91NJ7Meta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/news/news1113.vue").then(m => m.default || m)
  },
  {
    name: niumKXGBmSX4tjMeta?.name ?? "nium",
    path: niumKXGBmSX4tjMeta?.path ?? "/nium",
    meta: niumKXGBmSX4tjMeta || {},
    alias: niumKXGBmSX4tjMeta?.alias || [],
    redirect: niumKXGBmSX4tjMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/nium.vue").then(m => m.default || m)
  },
  {
    name: indexbwZgCAF2YqMeta?.name ?? "price",
    path: indexbwZgCAF2YqMeta?.path ?? "/price",
    meta: indexbwZgCAF2YqMeta || {},
    alias: indexbwZgCAF2YqMeta?.alias || [],
    redirect: indexbwZgCAF2YqMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/price/index.vue").then(m => m.default || m)
  },
  {
    name: proIdcRxhQTXSMeta?.name ?? "pro",
    path: proIdcRxhQTXSMeta?.path ?? "/pro",
    meta: proIdcRxhQTXSMeta || {},
    alias: proIdcRxhQTXSMeta?.alias || [],
    redirect: proIdcRxhQTXSMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/pro.vue").then(m => m.default || m)
  },
  {
    name: PriceXeC2pP6hayMeta?.name ?? "scheme-Price",
    path: PriceXeC2pP6hayMeta?.path ?? "/scheme/Price",
    meta: PriceXeC2pP6hayMeta || {},
    alias: PriceXeC2pP6hayMeta?.alias || [],
    redirect: PriceXeC2pP6hayMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/scheme/Price.vue").then(m => m.default || m)
  },
  {
    name: testAwQYuIsOemMeta?.name ?? "test",
    path: testAwQYuIsOemMeta?.path ?? "/test",
    meta: testAwQYuIsOemMeta || {},
    alias: testAwQYuIsOemMeta?.alias || [],
    redirect: testAwQYuIsOemMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/test.vue").then(m => m.default || m)
  },
  {
    name: xWAwW1YoS5SMeta?.name ?? "x",
    path: xWAwW1YoS5SMeta?.path ?? "/x",
    meta: xWAwW1YoS5SMeta || {},
    alias: xWAwW1YoS5SMeta?.alias || [],
    redirect: xWAwW1YoS5SMeta?.redirect || undefined,
    component: () => import("/home/deploy/webhook-lisenter/tduck-cms/pages/x.vue").then(m => m.default || m)
  }
]